<template>
  <div v-if="hasRound">
    <p v-if="loading">
      een moment geduld alstublieft...
    </p>
    <template v-else-if="confirmed">
      <div class="p--md">
        <div class="is-centered">
          <h1 v-if="!replay" class="title">Je stem is bevestigd!</h1>
          <h1 v-if="replay">Je stem is bevestigd</h1>
          <p v-if="nominees.length || suggestions.length" class="votes" style="margin-bottom: 1rem">
            <template v-for="nominee in nominees">
                <div class="confirmed-nominees">
                  <b class="categoryTitle">{{findCategoryName(nominee.categoryId)}}</b>
                  <img
                    class="vote"
                    v-if="nominee.image"
                    :src="nominee.image"
                    :key="nominee.id"
                    onerror="this.src='static/rr_fallback.png';"
                    style="background: linear-gradient(180deg ,#121212, transparent);"
                  />
                  <img class="vote" v-else src="static/rr_fallback.png" />
                  <h3 class="selectionHeader">{{ nominee.name }}</h3>
                  <h3 class="text-sm"> {{nominee.broadcaster}}</h3>
                  <h3  class="text-sm" v-for="stations in nominee.stations"> {{stations}}</h3>
                  <span class="selectionText" v-if="nominee.name !== nominee.secondaryName">{{ nominee.secondaryName }}</span>
                </div>
            </template>

            <template v-for="suggestion in suggestions">
              <div class="confirmed-nominees">
                <img class="vote" src="static/rr_fallback.png" />
                <span
                  style="width: 160px;
                  word-break: break-word;
                  font-size: 14px;
                  font-weight: bold;"
                >
                  {{ suggestion.name }}
                </span>
              </div>
            </template>
          </p>
          <p class="pb--lg">
            Bedankt voor het stemmen op de RadioRing!
          </p>
          <p class="pb--lg">
            Vergeet niet om je stem te delen met je vrienden via Facebook, X en WhatsApp!
          </p>
        </div>
        <div class="share-buttons">
          <a
            class="share__button facebook"
            :href="`https://facebook.com/sharer/sharer.php?u=${shareUrl}`"
            rel="noopener"
            target="_blank"
            title="Delen op Facebook"
          >
            <svg viewBox="0 0 320 512" aria-hidden="true" height="20">
              <path
                fill="currentColor"
                d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
              />
            </svg>
          </a>
          <a
            class="share__button x"
            :href="
              `https://twitter.com/intent/tweet/?text=${shareText}&amp;url=${shareUrl}&amp;hashtags=radioring2025`
            "
            rel="noopener"
            target="_blank"
            title="Delen op X"
          >
            <svg height="20" viewBox="0 0 1200 1227" xmlns="http://www.w3.org/2000/svg" fill="#000">
              <path
                d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
              />
            </svg>
          </a>
          <button type="submit" class="share__button whatsapp" title="Delen op WhatsApp" @click="whatsApp">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M19.355 4.552a10.328 10.328 0 0 0-7.36-3.052C6.258 1.5 1.59 6.169 1.59 11.906c0 1.833.478 3.624 1.388 5.203L1.5 22.5l5.517-1.448c1.519.83 3.23 1.265 4.974 1.265h.004c5.733 0 10.505-4.669 10.505-10.406 0-2.78-1.181-5.39-3.145-7.36zm-7.36 16.012A8.634 8.634 0 0 1 7.59 19.36l-.314-.187-3.272.858.872-3.192-.206-.329a8.62 8.62 0 0 1-1.322-4.603c0-4.767 3.881-8.648 8.653-8.648 2.31 0 4.481.9 6.112 2.536 1.632 1.636 2.635 3.806 2.63 6.117 0 4.772-3.98 8.653-8.747 8.653zm4.744-6.478c-.258-.131-1.537-.76-1.777-.844-.239-.089-.412-.131-.585.131-.174.263-.67.844-.825 1.022-.15.174-.305.197-.563.066-1.528-.764-2.531-1.364-3.539-3.094-.267-.46.267-.426.764-1.42.084-.174.042-.324-.023-.455-.066-.131-.586-1.41-.802-1.931-.21-.506-.427-.436-.586-.445-.15-.01-.323-.01-.497-.01a.963.963 0 0 0-.694.324c-.239.262-.909.89-.909 2.17 0 1.28.933 2.517 1.06 2.69.13.174 1.832 2.8 4.443 3.929 1.65.712 2.297.773 3.122.651.502-.075 1.538-.628 1.753-1.237.216-.61.216-1.13.15-1.238-.06-.117-.234-.182-.492-.31z"
                fill="#FFF"
                fill-rule="nonzero"
              />
            </svg>
          </button>
        </div>
      </div>
    </template>
    <p v-else-if="notFound" class="p--lg text--container">
      Deze bevestiging is ongeldig.
    </p>
  </div>
  <p v-else class="p--lg text--container">
    Er kan op dit moment niet (meer) gestemd worden.
  </p>
</template>

<script>
import { get } from '@/util/request'

const { FRONTEND_DOMAIN } = process.env

export default {
  name: 'Confirm',
  data() {
    return {
      loading: true,
      confirmed: false,
      replay: false,
      notFound: false,
      nomineeIds: [],
      suggestions: [],
      shareUrl: encodeURIComponent(FRONTEND_DOMAIN)
    }
  },
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  methods: {
    findCategoryName(categoryId) {
      const category = this.categories.find(category => category.id === Number(categoryId))
      return category.name
    },

    whatsApp() {
      const target = '_blank'
      const features = 'noopener,noreferrer'
      const platform = this.isMobile ? 'api' : 'web'
      const base = `https://${platform}.whatsapp.com/send`

      window.open(
        `${base}?text=${this.shareText.replace(/\s+/, ' ') + ' ' + decodeURIComponent(this.shareUrl)}`,
        target,
        features
      )
    }
  },
  computed: {
    loaded() {
      return this.$store.state.loaded
    },
    round() {
      return this.$store.state.rounds
    },
    hasRound() {
      return typeof this.round === 'object'
    },
    nominees() {
      return this.$store.state.nominees.filter(({ id }) => this.nomineeIds.includes(id))
    },
    categories() {
      return this.$store.state.categories
    },
    shareText() {
      const nominees = this.nominees.map(
        ({ name, hashtag }) => name + (hashtag && hashtag.length ? ` (${hashtag})` : '')
      )

      const suggestions = this.suggestions.map(
        ({ name, nameSecondary }) =>
          name + (nameSecondary && nameSecondary.length && nameSecondary !== '-' ? ` (${nameSecondary})` : '')
      )

      const sentence = [...nominees, ...suggestions].reduce((acc, curr, index, names) => {
        if (index === 0) {
          return curr
        }

        return index < names.length - 1 ? `${acc}, ${curr}` : `${acc} en ${curr}`
      }, '')

      return encodeURIComponent(
        `Ik heb gestemd op ${sentence}. Stem nu ook op jouw favoriete programma voor de RadioRing 2025!`
      )
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },

  mounted() {
    get(`voting/vote/confirm/${this.uuid}`)
      .then(response => {
        if (response.ok) {
          response.json().then(({ data }) => {
            const { confirmed, replay, notFound, nominees, suggestions } = data
            this.confirmed = confirmed
            this.replay = replay
            this.notFound = notFound
            this.suggestions = suggestions
            this.nomineeIds = nominees.map(Number)
            this.loading = false
          })
        } else {
          this.notFound = true
          this.loading = false
        }
      })
      .catch(() => {
        this.notFound = true
        this.loading = false
      })
    get(`voting/votes/${this.uuid}`)
      .then(response => response.json())
      .then(({ data }) => {
        const { votes } = data
        this.votedNominees = votes
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Confirm.vue